/* */ 
var classof = require('./$.classof'),
    ITERATOR = require('./$.wks')('iterator'),
    Iterators = require('./$.iterators');
module.exports = require('./$.core').getIteratorMethod = function(it) {
  if (it != undefined)
    return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
};
